import React, { useState } from "react";
import '@/css/shared.css';
import HomeScreen from "./slides/HomeScreen";
import VariationModal from '../games/chess/components/modals/VariantModal';
import JoinPrivateMatchModal from '../games/chess/components/modals/JoinPrivateMatch';
// Import types from centralized location
import type { User } from '@/shared/types';
import ShellSideContainer from "@/components/shell/ShellSideContainer";
import { HOME, type HomeState } from "@/shared/constants/home";
import Sessions from "./slides/Sessions";
import { GameState } from "@/shared/constants/game";
function Shell({ user, refetchUser, gameState, homeState, setHomeState }:
  {
    user: User | null,
    refetchUser: () => void,
    gameState: GameState,
    homeState: HomeState,
    setHomeState: (state: HomeState) => void
  }) {
  const [isVariationHelpModalOpen, setVariationHelpModalOpen] = useState(false);
  const [isJoinMatchModalOpen, setJoinMatchModalOpen] = useState(false);


  return(
    <div className="page-grid with-header">
        <div data-cy="home" className="contentGrid">
            <ShellSideContainer user={user} gameState={gameState}/>
            <div className="mainContent">
                {homeState === HOME.NONE ? 
                  <HomeScreen 
                    setHomeState={setHomeState} 
                    setVariationHelpModalOpen={setVariationHelpModalOpen} 
                    setJoinMatchModalOpen={setJoinMatchModalOpen} 
                  /> 
                  :
                  <Sessions
                    gameState={gameState}
                    homeState={homeState}
                    setHomeState={setHomeState}
                    refetchUser={refetchUser}
                    user={user}
                  />
                }
            </div>
            <VariationModal isVariationHelpModalOpen={isVariationHelpModalOpen} onClose={() => setVariationHelpModalOpen(false)} />
            <JoinPrivateMatchModal isJoinMatchModalOpen={isJoinMatchModalOpen} onClose={() => setJoinMatchModalOpen(false)}/>
        </div>
    </div>
  )
}

export default Shell;